import { AxiosRequestConfig } from 'axios';
import { http } from '../http';

export const uploadLoanDocument = (data: FormData, config?: AxiosRequestConfig) => {
  const headers = {
    'Accept': '*/*',
    'Content-Type': 'multipart/form-data',
  };

  return http.post('/api/loandocuments/proof-items', data, { ...config, headers });
};
